import React, { useMemo } from 'react'
import PageLayout from '../../../shared/ui/layouts/PageLayout/PageLayout'
import { StickyFilterBar } from '../../../shared/ui/layouts/StickyFilterBar'
import { selectGewerkOptions, useDashboardAggregatesQuery } from '../../../entities/dashboard'
import {
  ActiveFilterChips,
  DashboardFilterBar,
  useDashboardFilters,
} from '../../../features/dashboard-filters'
import { DashboardOverview } from '../../../widgets/dashboard-overview'

export const DashboardPage: React.FC = () => {
  const { filters, apiParams, months, yearOptions, monthOptions, actions } = useDashboardFilters()
  const query = useDashboardAggregatesQuery(apiParams)

  const cells = useMemo(() => query.data?.cells ?? [], [query.data])
  const gewerkOptions = useMemo(() => selectGewerkOptions(cells), [cells])
  const gewerkLabels = useMemo(
    () => Object.fromEntries(gewerkOptions.map((o) => [o.value, o.label])),
    [gewerkOptions],
  )
  const cellFilter = useMemo(
    () => ({ gewerke: filters.gewerke, status: filters.status }),
    [filters.gewerke, filters.status],
  )

  return (
    <PageLayout pageTitle="Dashboard">
      <div className="flex w-full flex-col gap-4">
        <StickyFilterBar>
          <DashboardFilterBar
            filters={filters}
            actions={actions}
            gewerkOptions={gewerkOptions}
            yearOptions={yearOptions}
            monthOptions={monthOptions}
          />
          <ActiveFilterChips
            gewerke={filters.gewerke}
            gewerkLabels={gewerkLabels}
            status={filters.status}
            onRemoveGewerk={actions.removeGewerk}
            onClearStatus={actions.clearStatus}
          />
        </StickyFilterBar>

        <DashboardOverview
          cells={cells}
          months={months}
          filter={cellFilter}
          metric={filters.metric}
          isLoading={query.isPending}
          isError={query.isError && !query.data}
          isRefreshing={query.isPlaceholderData}
          pricingAvailable={query.data?.pricingAvailable ?? true}
          now={new Date()}
          onToggleGewerk={actions.toggleGewerk}
          onToggleStatus={actions.toggleStatus}
          onMetricChange={actions.setMetric}
        />
      </div>
    </PageLayout>
  )
}
